import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'components/Common/FirebaseSaveIndicator/style.scss';

class FirebaseSaveIndicator extends Component {
  render() {
    const { lastSuccessfulWrite } = this.props;

    const hidden = Date.now() - lastSuccessfulWrite > 1250;

    if (!hidden) {
      setTimeout(() => this.forceUpdate && this.forceUpdate(), 1251);
    }

    /**
     * The save indicator should show 10px below the Appcues header or 10px below the top of the
     * window if the header isn't completely visible.  We have to break a few rules to accomplish
     * this... not thrilled, but can't think of anything better at the moment
     */

    const reactBody = document.querySelector('.apc-react-body');
    const reactBodyYPosn = reactBody
      ? reactBody.getBoundingClientRect().top + 55
      : 0;
    const autoSaveYPosn = Math.max(reactBodyYPosn, 10);

    return (
      <div
        className={`save-indicator ${hidden && 'save-indicator-hidden'}`}
        style={{ top: `${autoSaveYPosn}px` }}
      >
        All Changes Saved
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    lastSuccessfulWrite: state.firebase.lastSuccessfulWrite,
  };
}

export default connect(mapStateToProps)(FirebaseSaveIndicator);
